exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-info[data-v-5187e6b3]{background:#ecf5ff!important}.text-info[data-v-5187e6b3]{color:#409eff!important}", ""]);

// exports
